/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState, useMemo } from 'react'
import { withTranslation } from 'react-i18next'
import styles from './RenewalPeriod.module.scss'
import { useHistory } from 'react-router-dom'
import BackNextButtons from 'shared/components/BackNextButtons.jsx'
import {
  renewalPeriodAction,
  editPermitAction,
  addPermitAction,
  editPlateNumberAction,
  clearAllUserDataAction,
  masterNumberAction,
  plateNumberAction,
  vinSerialNumberAction,
} from 'redux/actions'
import { useDispatch, useSelector } from 'react-redux'
import BackAnchor from '../../../../shared/components/BackAnchor'
import { parsePeriodText } from 'redux/reducers/apiReducers/processMasterNumberReducer'

const sumExtraFees = (extraFees) => {
  return extraFees.reduce((prevVal, newVal) => {
    return prevVal + parseFloat(newVal.extraFeeAmount)
  }, 0)
}

const getRenewalAmount = (amount, extraFees) => {
  const extraFeesAmount = sumExtraFees(extraFees)
  return parseFloat(amount) + extraFeesAmount
}

const RenewalPeriodView = ({ t, i18n, setIsError }) => {
  const dispatch = useDispatch()
  const history = useHistory()

  const {
    permits,
    renewalPeriod,
    masterNumber,
    plateNumber,
    vinSerialNumber,
    editPlateNumber,
    editFromConfirmation,
    vehicleType,
    commercialAquaculture,
    fishingVessel,
  } = useSelector((state) => state.app)

  const backNextProps = {
    prevText: t('shared.cancel'),
    prevURL: i18n.language === 'en' ? process.env.REACT_APP_PAGE_NOT_FOUND_URL : process.env.REACT_APP_PAGE_NOT_FOUND_URL_FR, //`/${i18n.language}${t('routes.address_update_question')}`,
    nextText: t('shared.next'),
  }

  const [errorMsg, setErrorMsg] = useState('')

  const { vehicleResponse } = useSelector((state) => state.vehicleDataAPI)

  const renewalperiods = useMemo(() => vehicleResponse['feeTerms'], [vehicleResponse])

  // useEffect(() => {
  //   try {
  //     if (editPlateNumber || permits.length === 0) {
  //     } else {
  //       dispatch(clearAllUserDataAction())
  //     }
  //   } catch (e) {
  //     console.log(e)
  //   }
  // }, [])

  useEffect(() => {
    try {
      if (masterNumber === '' || plateNumber === '' || vinSerialNumber === '') {
        history.push(`/${i18n.language}${t('routes.your_info')}`)
      }
      if (renewalperiods.length === 1) {
        const fee = getRenewalAmount(renewalperiods[0]['fee'], renewalperiods[0]['extraFees'])
        const term = renewalperiods[0]['term']
        dispatch(renewalPeriodAction(term, fee, renewalperiods[0]['extraFees']))
      }
    } catch (e) {
      console.log(e)
      setIsError(true)
    }
  }, [dispatch, history, i18n.language, masterNumber, plateNumber, renewalperiods, setIsError, t, vinSerialNumber])

  useEffect(() => {
    if (renewalperiods.length === 1 && renewalPeriod.amount !== '' && renewalPeriod.period !== '') {
      let requiresInsurance = vehicleResponse.vehicleData.requiresInsurance
      localStorage.setItem('requiresInsurance', requiresInsurance)
      if (requiresInsurance) {
        history.push({
          pathname: `/${i18n.language}${t('routes.insurance_info')}`,
          state: {
            backLink: `routes.your_info`,
            backIndex: -2,
          },
        })
      } else {
        fullProcessAddpermit()
      }
    }
  }, [renewalPeriod, vehicleResponse, renewalperiods])

  const fullProcessAddpermit = () => {
    if (editPlateNumber) {
      dispatch(
        editPermitAction({
          plateNumber,
          vinSerialNumber,
          insuranceCompany: '',
          policyNumber: '',
          effectiveDate: '',
          expiryDate: '',
          renewalPeriod: renewalPeriod['period'],
          renewalAmount: renewalPeriod['amount'],
          extraFees: renewalPeriod['extraFees'],
          vehicleClass: vehicleResponse['vehicleData']['vehicleClass'],
          vehicleFuelType: vehicleResponse['vehicleData']['vehicleFuelType'],
          vehicleType,
          commercialAquaculture,
          fishingVessel,
        })
      )
      // console.log('permit case 1')
    } else {
      if (!checkIsPlateExists()) {
        dispatch(
          addPermitAction({
            plateNumber,
            vinSerialNumber,
            insuranceCompany: '',
            policyNumber: '',
            effectiveDate: '',
            expiryDate: '',
            renewalPeriod: renewalPeriod['period'],
            renewalAmount: renewalPeriod['amount'],
            extraFees: renewalPeriod['extraFees'],
            vehicleClass: vehicleResponse['vehicleData']['vehicleClass'],
            vehicleFuelType: vehicleResponse['vehicleData']['vehicleFuelType'],
            vehicleType,
            commercialAquaculture,
            fishingVessel,
          })
        )
        // console.log('permit case 2')
      } else {
        if (permits.length === 1) {
          const holdMasterNumber = masterNumber,
            holdPlateNumber = plateNumber,
            holdVinSerialNumber = vinSerialNumber
          dispatch(clearAllUserDataAction())
          dispatch(masterNumberAction(holdMasterNumber))
          dispatch(plateNumberAction(holdPlateNumber))
          dispatch(vinSerialNumberAction(holdVinSerialNumber))
          history.push(`/${i18n.language}${t('routes.your_info')}`)
          // console.log('permit case 3')
        } else {
          history.push(`/${i18n.language}${t('routes.add_permit')}`)
          // console.log('permit case 4')
        }
        return
      }
    }
    dispatch(editPlateNumberAction(''))
    if (editFromConfirmation) {
      history.push(`/${i18n.language}${t('routes.review_confirmation')}`)
      // console.log('permit case 5')
    } else {
      // history.push(`/${i18n.language}${t('routes.listed_permits')}`)
      history.push(`/${i18n.language}${t('routes.contact_info')}`)
      // console.log('permit case 6')
    }
  }

  const checkIsPlateExists = () => {
    let isExists = false
    if (permits.length > 0) {
      isExists = permits.filter((permit) => permit.plateNumber === plateNumber).length > 0
    }
    return isExists
  }

  const handleRadio = (term, extraFees) => (e) => {
    try {
      let elem = e.currentTarget.value
      let [, fee] = elem.split('-')
      dispatch(renewalPeriodAction(term, fee, extraFees))
    } catch (err) {
      console.log(err)
    }
  }

  const onRenewalClick = () => {
    try {
      if (renewalPeriod && renewalPeriod.amount && renewalPeriod.period) {
        dispatch(renewalPeriodAction(renewalPeriod.period, renewalPeriod.amount, renewalPeriod.extraFees))
        if (vehicleResponse['vehicleData']['requiresInsurance']) {
          history.push(`/${i18n.language}${t('routes.insurance_info')}`)
        } else {
          fullProcessAddpermit()
        }
      } else {
        setErrorMsg(t('renewal_period.select_renewal'))
      }
    } catch (err) {
      console.log(err)
    }
  }

  const getAmountText = (amount, language) => {
    const num = parseFloat(amount * 0.01).toFixed(2)
    return language === 'en' ? `$${num}` : `${num.toString().replace('.', ',')} $`
  }

  return (
    <div className="container">
      <div className="row">
        <div className="col-xs-12 col-lg-8">
          <BackAnchor />
        </div>
      </div>
      <div className="row">
        <div className="col-xs-12 col-lg-8">
          <h1>{t('title')}</h1>
        </div>
      </div>
      <div className="row">
        <div className="col-xs-12 col-lg-8">
          <h3>{t('renewal_period.select_renewal')}</h3>
        </div>
      </div>
      {renewalperiods.length !== 2 && (
        <div className="row">
          <div className="col-xs-12 col-lg-8">
            <p>{t('renewal_period.for_example')}</p>
          </div>
        </div>
      )}
      <div className="row">
        <div className="col-xs-12 col-lg-8">
          {renewalperiods.map((eachPeriod, i) => {
            const amount = getRenewalAmount(eachPeriod.fee, eachPeriod.extraFees)

            const amountText = getAmountText(amount, i18n.language)
            const durationText = parsePeriodText(eachPeriod.term, i18n.language)
            const labelText = `${durationText} - ${amountText}`
            const elemValue = `${durationText}-${amount}`

            return (
              <div className="ns-radios__item" key={i}>
                <input
                  className="ns-radios__input"
                  type="radio"
                  id={elemValue}
                  value={elemValue}
                  onChange={handleRadio(eachPeriod.term, eachPeriod.extraFees)}
                  checked={parsePeriodText(eachPeriod['term'], i18n.language) === parsePeriodText(renewalPeriod['period'], i18n.language)}
                />
                <label className="ns-label ns-radios__label" htmlFor={labelText} key={labelText}>
                  <span className="ns-label-span">{labelText} </span>
                </label>
              </div>
            )
          })}
        </div>
      </div>
      <div className={styles['error_margin']}>
        <BackNextButtons props={backNextProps} nextOnClick={onRenewalClick} errorMsg={errorMsg} displayBack={true} />
      </div>
    </div>
  )
}

export default withTranslation('common')(RenewalPeriodView)
